



import React from 'react'
import './Development.css'



const Development:React.FC = () => {



  return (
    <>
    <div className='w-screen overflow-hidden min-h-screen p-10 custom-development-container '>
        <div className='flex flex-col items-center justify-center mx-auto max-w-[800px]'>
            <div  className=' sm:text-lg md:text-xl lg:text-3xl xl:text-4xl  font-sans'><h3>Training & Development Guides</h3></div>
            <div className=' text-center font-sans w-[80%] p-10'><p>At Next Play Nation, we’re committed to unlocking every athlete’s full 
                potential through structured Training & Development Guides. Our resources are designed to help you build strength, sharpen your skills,
                 and enhance your performance in a safe and progressive way. Whether you’re just starting out or looking to elevate your game, our step-by-step guides 
                and expert tips ensure you have the tools and support needed to grow both physically and mentally—every step of your journey.</p></div>




        </div>
    </div>
    
    
    
    
    
    
    </>
  )
}

export default Development
